import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MinorNotice = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ mb: 3 }}>
            <Alert severity="warning">
                <Typography variant="body1" fontWeight="bold">
                    {t('Register.Minor')}
                </Typography>
                <Typography variant="body2">{t('Register.MinorText')}</Typography>
            </Alert>
        </Box>
    );
};

export default MinorNotice;
